<template>
  <O3D>
    <!-- <SwatWalk></SwatWalk> -->
    <Church></Church>
    <!-- <FactoryPlace></FactoryPlace> -->

    <O3D :py="40" :pz="-100">
      <O3D layout="loklok">
        <WoozyLayer :pz="-5" :py="8"></WoozyLayer>
        <LokLokText></LokLokText>
      </O3D>
    </O3D>

    <O3D layout="overall">

      <O3D layout="diamonds">
        <WoozyDiamonds :py="6">
          <SpriteLabel :sx="0.5" :sy="0.5" :sz="0.5" :pz="-15" :py="16" text="放閃"></SpriteLabel>
        </WoozyDiamonds>
      </O3D>

      <O3D :py="15" :px="0" :pz="-200">
        <SpriteLabel :sx="0.5" :sy="0.5" :sz="0.5" :pz="0"  :py="45" text="太空">
        </SpriteLabel>
        <!-- <StarField :sx="1" :sy="1" :sz="1" :py="15" :ry="0.0 * 3.141592 * 0.75">
        </StarField> -->
        <StarField :sx="1" :sy="1" :sz="1" :py="15" :ry="0.0 * 3.141592 * 0.75">
        </StarField>
      </O3D>

      <O3D :py="25" :px="-0" :pz="80">
        <SpriteLabel :sx="0.5" :sy="0.5" :sz="0.5" :pz="0"  :py="30" text="花球">
        </SpriteLabel>
        <ParametricRain></ParametricRain>
      </O3D>

      <O3D :py="15" :px="0" :pz="150">
        <SpriteLabel :sx="0.25" :sy="0.25" :sz="0.25" :pz="0"  :py="25" text="電波">
        </SpriteLabel>
        <ParametricCluster></ParametricCluster>
      </O3D>

      <!-- <O3D layout="jellyfish">
        <JellyFish>
          <SpriteLabel :sx="0.5" :sy="0.5" :sz="0.5" :pz="0" :py="32.5" text="水母💧">
          </SpriteLabel>
        </JellyFish>
      </O3D> -->

      <O3D layout="flower">
        <Flower>
          <SpriteLabel :sx="0.05" :sy="0.05" :sz="0.05" :pz="0" :py="3" text="櫻花🌸">
          </SpriteLabel>
        </Flower>
      </O3D>

      <O3D layout="glowball">
        <GlowBall></GlowBall>
      </O3D>

      <O3D layout="fruits">
        <FruitCollection></FruitCollection>
      </O3D>

      <O3D layout="woozyball">
        <WoozyBall>
          <SpriteLabel :sx="1" :sy="1" :sz="1" :pz="0" :py="15" text="水果">
          </SpriteLabel>
        </WoozyBall>
      </O3D>

    </O3D>
  </O3D>
</template>

<script>
import { O3DG2 } from '../../Reusable/O3DG2'

export default {
  mixins: [O3DG2],
  data () {
    return {
      PI: Math.PI,
      layouts: {}
    }
  },
  methods: {
    async setup () {
      let lay = this.layouts
      this.onLoop(() => {
        lay.loklok = {
          pz: 0,
          py: 20
        }
        lay.diamonds = {
          pz: -100,
          py: 15
        }
        lay.ball = {
          pz: -100
        }
        lay.flower = {
          pz: -100,
          py: 15,
          px: 100,
          sx: 10,
          sy: 10,
          sz: 10
        }
        lay.jellyfish = {
          pz: -50,
          px: -100
        }
        lay.glowball = {
          pz: -200,
          py: 15,
          px: -100
        }
        lay.fruits = {
          pz: -300,
          py: 16,
          px: 100
        }
        lay.woozyball = {
          pz: -300,
          py: 6,
          px: 100
        }
        lay.overall = {
          pz: -250
        }
      })
    }
  },
  mounted () {
    this.setup()
  }
}
</script>

<style>

</style>